import React from "react";
import { func, string } from "prop-types";
import Button from "pages/_components/Button";
import { useTags } from "pages/creditBills/hooks/useTags";

import { WithContext as ReactTags } from "react-tag-input";

const FilterTags = ({ openSideBarFilters, tabOption }) => {
    const { tags, handleDelete, handleCleanFilters } = useTags(tabOption);

    return (
        <div className="tags-filter">
            <Button
                image="images/figma/icon/filter.svg"
                onClick={openSideBarFilters}
                label="global.filter"
                className="btn btn-link open-filters"
                block={false}
            />
            {tags.length > 0 ? (
                <>
                    <ReactTags
                        autofocus={false}
                        tags={tags}
                        handleDelete={handleDelete}
                        allowDragDrop={false}
                        placeholder=""
                        inputProps={{
                            disabled: true,
                            autocomplete: "off",
                        }}
                        classNames={{
                            tags: "tagsClass",
                            selected: "selectedClass",
                            tag: "tagClass",
                            remove: "removeClass",
                        }}
                    />
                    <Button
                        image="images/figma/icon/clear-filter.svg"
                        onClick={handleCleanFilters}
                        label="echecks.clean.filters"
                        className="btn btn-link clear-filters"
                        block={false}
                        icon=""
                    />
                </>
            ) : null}
        </div>
    );
};

FilterTags.propTypes = {
    openSideBarFilters: func.isRequired,
    tabOption: string.isRequired,
};

export default FilterTags;
